import React from 'react';
/**
 * `WhySection` renders the "Why" marketing section on landing pages.
 *
 * It displays the CMS header/description and optionally renders `WhyTabs` when
 * `showWhyTabs` is enabled.
 */

import './WhySection.scss';
import WhyTabs from './WhyTabs';
import { WhySectionCustomisation } from '../../../common/CommonTypes';

export type WhySectionProps = {
  cms: WhySectionCustomisation;
  showWhyTabs: boolean;
};

const WhySection = ({ cms, showWhyTabs }: WhySectionProps): JSX.Element => {
  return (
    <div className='m1-bottom m4-top'>
      <div className='flex-column why--section'>
        <h2 className='lp-why-section-header'>{cms.whySectionHeader}</h2>
        <p className='lp-why-section'>{cms.whySectionDescription}</p>
      </div>
      {showWhyTabs && <WhyTabs cms={cms.whySectionLists} />}
    </div>
  );
};

export default WhySection;
